import CustomCard from "components/Atoms/CustomCard"
import BackButton from "components/Templates/BackButton"
import { pick } from "lodash-es"
import React from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import ConsolidatedOrderForm from "./ConsolidatedOrderForm"
import OrderPayment from "./OrderPayment"
import OrderSummary from "./OrderSummary"
import { useAddOrder } from "./useAddOrder"
const AddConsolidatedOrder = () => {
  const [order, setOrder, distributionCenter] = useAddOrder()
  const location = useLocation()
  const path = location.pathname
  return (
    <div>
      <CustomCard>
        <div className="flex items-baseline ">
          <BackButton
            disabled={order?.id && path.includes("invoice") ? true : false}
          />
          <h4 className="mr-6 w-full text-center">
            <Routes>
              <Route
                path="invoice"
                element={
                  <>
                    <span className="vt-muted"> Order</span> - Summary
                  </>
                }
              />
              <Route
                path="payment"
                element={
                  <>
                    <span className="vt-muted">Payment for order</span> -{" "}
                    {order?.trackingCode}
                  </>
                }
              />
              <Route
                index
                element={
                  <>
                    <span className="vt-muted"> Order - Consolidated</span>
                  </>
                }
              />
            </Routes>
          </h4>
        </div>
      </CustomCard>
      <div className="p-3">
        <CustomCard>
          <div className="container">
            <Routes>
              <Route
                path="invoice"
                element={
                  <OrderSummary
                    defaultAddress={order?.user?.address}
                    order={order}
                    onOrderAdd={ord => {
                      setOrder(prev => ({
                        ...prev,
                        ...pick(ord, [
                          "id",
                          "totalAmount",
                          "totalPaid",
                          "trackingCode",
                        ]),
                      }))
                    }}
                  />
                }
              />
              <Route
                path="payment"
                element={
                  <OrderPayment
                    order={order}
                    onPaymentComplete={ord =>
                      setOrder(prev => ({
                        ...prev,
                        totalPaid: ord?.totalPaid,
                      }))
                    }
                  />
                }
              />
              <Route
                index
                element={
                  <ConsolidatedOrderForm
                    distributionCenter={distributionCenter}
                    order={order}
                    onChange={order => setOrder(order)}
                  />
                }
              />
            </Routes>
          </div>
        </CustomCard>
      </div>
    </div>
  )
}

export default AddConsolidatedOrder
